<template>
  <div>
    <Breadcrumb :options="breadcrumb" />

    <div class="info_form">
      <el-form ref="form" :model="form" :label-width="labelWidth">
        <!-- <div class="tit_label">车辆添加</div> -->

        <div class="bainfo">
          <FormItem v-for="(c, i) in formCtrl" :key="'formItem' + i" :viewMode="viewMode" :config="c"
            :options="c.options" :inputValue="form[c.keyName]" @onChange="onChange" :class="c.className" />
        </div>
      </el-form>
    </div>

    <div class="btns">
      <el-button @click="cancel">返 回</el-button>
    </div>
  </div>
</template>

<script>
import detailMixin from "../../mixin/detail";
import mixin from "./mixin";

export default {
  mixins: [detailMixin, mixin],
  data() {
    return {
      breadcrumb: [
        { name: "车辆管理", path: `/vehicle/manage` },
        { name: "车辆列表", path: `/vehicle/manage` },
        { name: "车辆查看" },
      ],
      viewMode: true,
      labelWidth: '180px',
    };
  },
  methods: {},
  mounted() { },
};
</script>

<style lang="less" scoped>
/deep/ .el-form {
  background-color: #fff;
  padding-top: 20px;
  border-radius: 5px;
  box-shadow: 0px 0px 10px rgb(0 0 0 / 3%);

  .subform::before {
    width: 110%;
    height: 10px;
    background: #F9F9F9;
    content: '';
    //margin-bottom: 20px;
  }

  .subform {
    // padding-top: 22px;
    margin-bottom: 0px;
  }

  .el-form-item {
    // border-bottom: 1px solid #f2f6fc;
    padding: 0 20px 0 0;

    .el-input {
      width: 200px;
    }

    /*.el-form-item__content > div {
        width: 300px;
    }*/
  }
}

.instyle {
  display: inline-block;
  overflow: hidden;
  margin-bottom: 0;
}

.bainfo {
  padding-bottom: 20px;
}

/*.info_form .el-form .el-form-item:nth-child(9) {
  display: block;
}*/
/deep/ .el-form .el-form-item {
  &.remind .content {
    display: block;

    .left:nth-child(2) {
      margin-left: 180px;
    }
  }

  &.view {
    .content {
      .left:nth-child(2) {
        margin-left: 192px;
      }
    }
  }
}

/deep/ .self {
  >.el-form-item__label {
    float: none !important;
    display: block;
    margin: 39px 0 18px 112px;
    text-align: left;
    font-size: 18px;
    color: #333;
  }

  >.el-form-item__content {
    margin-left: 0 !important;
  }
}

.el-form .el-row:nth-child(4) .el-col-8 .subform::before {
  display: none;
}

.el-form .el-row:nth-child(4) .el-col-16 .subform::before {
  display: none;
}

.el-col-16 .self {
  margin-left: -54px;
}

.el-row .el-col .self:first-child {
  margin-bottom: 50px;
}

/deep/.info_form .el-form .el-row:nth-child(2) {
  padding-bottom: 20px;
}

/deep/ .subform .el-row .el-col-8 .el-form-item:last-child {
  margin-bottom: 40px;
}

.tit_label {
  margin: 26px 0 26px 112px;
  font-size: 18px;
  color: #333;
}

/deep/ .instyle .el-form-item__content {
  width: 300px;
}

/deep/ .el-row .el-form-item {
  margin-bottom: 0px;
}


/deep/.el-icon-arrow-right:before {
  content: '';
}

/deep/ .breadcrumb .el-icon-arrow-right:before {
  content: "\e6e0";
}

.btns {
  margin: 40px 0 60px 180px;
}
</style>
